import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

const PLACEHOLDER = (kind) => [
  `[Placeholder — replace with the ${kind} text used across the Antelli group.]`,
  `This page is shared by all five Antelli brands, each of which links here. Keep one canonical version so the whole group stays consistent.`,
  `Suggested sections for the final text: who we are and how to reach us; what information is collected and why; how it is stored and for how long; cookies and analytics; third-party services; the rights of visitors (including Australian Privacy Act considerations); and how this policy is updated.`,
  `Last updated: [date]. Contact: support@antellihq.com.`,
];

const TERMS_PLACEHOLDER = [
  "[Placeholder — replace with the terms of use text used across the Antelli group.]",
  "This page is shared by all five Antelli brands, each of which links here. Keep one canonical version so the whole group stays consistent.",
  "Suggested sections for the final text: acceptance of terms; intellectual property; acceptable use; links to third-party sites; disclaimers and limitation of liability; governing law (Queensland, Australia); and how these terms are updated.",
  "Last updated: [date]. Contact: support@antellihq.com.",
];

const LegalLayout = ({ testId, title, heading, description, paragraphs }) => (
  <div data-testid={testId}>
    <Seo title={`${title} — Antelli`} description={description} />
    <div className="max-w-3xl mx-auto px-6 sm:px-10 pt-24 pb-24 sm:pt-36 sm:pb-36">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-[#7A6034]">{title}</p>
        <h1
          data-testid={`${testId}-heading`}
          className="mt-6 font-serif-display text-4xl sm:text-5xl leading-tight text-[#1A1C23] font-medium"
        >
          {heading}
        </h1>
        <div className="mt-12 space-y-6">
          {paragraphs.map((p, i) => (
            <p key={i} className="text-base leading-relaxed text-[#4A4D57]">
              {p}
            </p>
          ))}
        </div>
      </Reveal>
    </div>
  </div>
);

export const Privacy = () => (
  <LegalLayout
    testId="privacy-page"
    title="Privacy"
    heading="Privacy policy"
    description="The Antelli group privacy policy, shared across all five brands."
    paragraphs={PLACEHOLDER("privacy policy")}
  />
);

export const Terms = () => (
  <LegalLayout
    testId="terms-page"
    title="Terms"
    heading="Terms of use"
    description="The Antelli group terms of use, shared across all five brands."
    paragraphs={TERMS_PLACEHOLDER}
  />
);
